import PropTypes from "prop-types";
import CommonTextEditorInner from "components/common/CommonTextEditorInner";

/** Eager import: lazy + Suspense re-showed "Loading editor…" whenever the inner tree remounted (TipTap + StrictMode). */
export default function CommonTextEditor(props) {
  return <CommonTextEditorInner {...props} />;
}

CommonTextEditor.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  height: PropTypes.number,
  toolbarOptions: PropTypes.object,
  error: PropTypes.string,
  disabled: PropTypes.bool,
  characterLimit: PropTypes.number,
  /** Sets the ProseMirror root `id` for `label htmlFor` accessibility. */
  editorFieldId: PropTypes.string,
};
